/**
 * Pine Ridge Insurance rates for Coventry Homes communities in San Antonio
 * Data source: Pineridge_Insurance_Coventry_SA_combined_rates.pdf
 */

export interface InsuranceRate {
  model: string;
  sqft: number;
  annualPremium: number;
}

export interface CommunityInsuranceRates {
  community: string;
  rates: InsuranceRate[];
}

export const COVENTRY_INSURANCE_RATES: CommunityInsuranceRates[] = [
  {
    community: "Buffalo Crossing",
    rates: [
      { model: "Denison", sqft: 2358, annualPremium: 745 },
      { model: "Hart", sqft: 2574, annualPremium: 805 },
      { model: "Groveton", sqft: 2722, annualPremium: 835 },
      { model: "Collin", sqft: 2800, annualPremium: 855 },
      { model: "Hideaway", sqft: 2843, annualPremium: 866 },
      { model: "Brookshire", sqft: 3063, annualPremium: 923 },
      { model: "Willis", sqft: 3189, annualPremium: 954 },
      { model: "Caddo Mills", sqft: 3369, annualPremium: 999 },
      { model: "Logan II", sqft: 3376, annualPremium: 1000 },
      { model: "Motley", sqft: 3552, annualPremium: 1042 },
    ]
  },
  {
    community: "Davis Ranch 45'",
    rates: [
      { model: "Kendalia", sqft: 1607, annualPremium: 923 },
      { model: "Yorktown", sqft: 1941, annualPremium: 728 },
      { model: "Parker", sqft: 2051, annualPremium: 1116 },
      { model: "Gaines", sqft: 2168, annualPremium: 978 },
      { model: "Hale", sqft: 2170, annualPremium: 978 },
      { model: "Lasara", sqft: 2364, annualPremium: 1149 },
      { model: "Woodlake", sqft: 2580, annualPremium: 1168 },
      { model: "Milano", sqft: 2708, annualPremium: 1211 },
    ]
  },
  {
    community: "Foxbrook - Signature",
    rates: [
      { model: "Izoro", sqft: 1627, annualPremium: 618 },
      { model: "Kennedale", sqft: 2366, annualPremium: 746 },
      { model: "Calvert", sqft: 2519, annualPremium: 748 },
      { model: "Hart", sqft: 2574, annualPremium: 805 },
      { model: "Goodrich", sqft: 2581, annualPremium: 755 },
      { model: "Schertz", sqft: 2892, annualPremium: 880 },
      { model: "Brookshire", sqft: 3063, annualPremium: 923 },
      { model: "Granger", sqft: 3118, annualPremium: 891 },
    ]
  },
  {
    community: "Garden Grove",
    rates: [
      { model: "Clay", sqft: 1250, annualPremium: 562 },
      { model: "Gray", sqft: 1433, annualPremium: 624 },
      { model: "Hill", sqft: 1532, annualPremium: 653 },
      { model: "Kerr", sqft: 1647, annualPremium: 686 },
      { model: "King", sqft: 1808, annualPremium: 724 },
      { model: "Lynn", sqft: 2192, annualPremium: 810 },
    ]
  },
  {
    community: "Homestead 65'",
    rates: [
      { model: "Kennedale", sqft: 2419, annualPremium: 761 },
      { model: "Calvert", sqft: 2551, annualPremium: 797 },
      { model: "Hart", sqft: 2574, annualPremium: 805 },
      { model: "Goodrich", sqft: 2581, annualPremium: 806 },
      { model: "Dumont", sqft: 2897, annualPremium: 880 },
      { model: "Brookshire", sqft: 3063, annualPremium: 923 },
      { model: "Granger", sqft: 3118, annualPremium: 936 },
      { model: "Caddo Mills", sqft: 3369, annualPremium: 999 },
    ]
  },
  {
    community: "Homestead 75'",
    rates: [
      { model: "Groveton", sqft: 2722, annualPremium: 835 },
      { model: "Augusta II", sqft: 2726, annualPremium: 837 },
      { model: "Hideaway", sqft: 2843, annualPremium: 866 },
      { model: "Boca II", sqft: 3003, annualPremium: 907 },
      { model: "Meadowlakes", sqft: 3048, annualPremium: 918 },
      { model: "Willis", sqft: 3189, annualPremium: 954 },
      { model: "Zavalla", sqft: 3223, annualPremium: 964 },
      { model: "Wichita", sqft: 3470, annualPremium: 1022 },
      { model: "Motley", sqft: 3552, annualPremium: 1042 },
      { model: "Haskell", sqft: 3580, annualPremium: 1048 },
    ]
  },
  {
    community: "Ladera 40",
    rates: [
      { model: "Progreso", sqft: 2122, annualPremium: 918 },
      { model: "Riviera", sqft: 2344, annualPremium: 961 },
      { model: "Bloomburg", sqft: 2475, annualPremium: 988 },
    ]
  },
  {
    community: "Ladera 50",
    rates: [
      { model: "Childress", sqft: 2028, annualPremium: 774 },
      { model: "Kennedale", sqft: 2419, annualPremium: 904 },
      { model: "Bryan", sqft: 2465, annualPremium: 922 },
      { model: "Callisburg", sqft: 2504, annualPremium: 945 },
      { model: "Goodrich", sqft: 2581, annualPremium: 966 },
      { model: "Dumont", sqft: 2926, annualPremium: 1078 },
      { model: "Granger", sqft: 3118, annualPremium: 1144 },
      { model: "Kendall II", sqft: 3238, annualPremium: 1188 },
    ]
  },
  {
    community: "Mayfair 50'",
    rates: [
      { model: "Grandview", sqft: 2088, annualPremium: 678 },
      { model: "Lasara", sqft: 2108, annualPremium: 681 },
      { model: "Kennedale", sqft: 2419, annualPremium: 761 },
      { model: "Callisburg", sqft: 2504, annualPremium: 785 },
      { model: "Goodrich", sqft: 2581, annualPremium: 806 },
      { model: "Gallatin", sqft: 2833, annualPremium: 865 },
      { model: "Dumont", sqft: 2926, annualPremium: 888 },
      { model: "Granger", sqft: 3118, annualPremium: 936 },
      { model: "Kendall II", sqft: 3238, annualPremium: 968 },
    ]
  },
  {
    community: "Mayfair 60'",
    rates: [
      { model: "Groveton", sqft: 2722, annualPremium: 835 },
      { model: "Collin", sqft: 2800, annualPremium: 855 },
      { model: "Hideaway", sqft: 2843, annualPremium: 866 },
      { model: "Dumont", sqft: 2897, annualPremium: 880 },
      { model: "Willis", sqft: 3189, annualPremium: 954 },
      { model: "Caddo Mills", sqft: 3369, annualPremium: 999 },
      { model: "Wichita", sqft: 3470, annualPremium: 1022 },
      { model: "Motley", sqft: 3552, annualPremium: 1042 },
      { model: "Haskell", sqft: 3580, annualPremium: 1048 },
    ]
  },
  {
    community: "Megans Landing 50'",
    rates: [
      { model: "Leona", sqft: 1673, annualPremium: 786 },
      { model: "Grandview", sqft: 2041, annualPremium: 869 },
      { model: "Progresso", sqft: 2080, annualPremium: 820 },
      { model: "Hale", sqft: 2119, annualPremium: 872 },
      { model: "Denison", sqft: 2358, annualPremium: 978 },
      { model: "Bryan", sqft: 2465, annualPremium: 1004 },
      { model: "Goodrich", sqft: 2538, annualPremium: 1003 },
      { model: "Dumont", sqft: 2897, annualPremium: 1088 },
    ]
  },
  {
    community: "Megans Landing 70'",
    rates: [
      { model: "Chilton", sqft: 2599, annualPremium: 1024 },
      { model: "Hideaway", sqft: 2843, annualPremium: 1152 },
      { model: "Hamilton", sqft: 2866, annualPremium: 1155 },
      { model: "Willis", sqft: 3189, annualPremium: 1216 },
      { model: "Newport", sqft: 3235, annualPremium: 1229 },
      { model: "Motley", sqft: 3552, annualPremium: 1317 },
      { model: "Weston", sqft: 3622, annualPremium: 1337 },
    ]
  },
  {
    community: "Nopal Valley",
    rates: [
      { model: "Yorktown", sqft: 1970, annualPremium: 733 },
      { model: "Kennedale", sqft: 2447, annualPremium: 852 },
      { model: "Callisburg", sqft: 2525, annualPremium: 877 },
      { model: "Goodrich", sqft: 2606, annualPremium: 901 },
      { model: "Milano", sqft: 2724, annualPremium: 923 },
      { model: "Dumont", sqft: 2926, annualPremium: 980 },
      { model: "Granger", sqft: 3142, annualPremium: 1040 },
      { model: "Kendall II", sqft: 3270, annualPremium: 1074 },
    ]
  },
  {
    community: "Overlook at Creekside",
    rates: [
      { model: "Milano", sqft: 2659, annualPremium: 934 },
    ]
  }
];

// Average rate per square foot across all data (for fallback calculations)
export const AVERAGE_RATE_PER_SQFT = 0.32;
